module.exports = __webpack_public_path__ + "assets/img/bg_2-zi.d636c6fc.png";